export const REQUESTS_ABSENCE_PATH = "/requests/absence";
